// extracted by mini-css-extract-plugin
export default {"container":"ArtifactImagesSwiper_container__G7RmA","inner":"ArtifactImagesSwiper_inner__GdeIp"};